import ProgressBar from "@ramonak/react-progress-bar";

import './App.css';

const today = new Date();
const startDate = new Date('2022-12-28');

// count the days bewteen two dates
const daysBetween = (date1, date2) => {
  const oneDay = 1000 * 60 * 60 * 24;
  return Math.ceil((date2.getTime() - date1.getTime()) / oneDay) - 2;
};
const daysUntilEnd = daysBetween(startDate, today);

function calcResultFromSelicDia(selic) {
  const selicDia = selic/365;
  const selicDiaTotal = selicDia * daysUntilEnd;
  return selicDiaTotal * 2750;
}

function nextMilestone(currentValue) {
  const months = currentValue/30;
  return Math.ceil(months) * 30;
}

const App = () => {
  const fullCDI = calcResultFromSelicDia(0.13);
  const littleMore = calcResultFromSelicDia(0.143);
  const nextMilestoneValue = nextMilestone(daysUntilEnd);

  return (
    <div className="App" style={{'width': '100%'}}>
      <div>
        <div>
          Completaram-se exatamente {daysUntilEnd} dias desde quando a placa de vídeo foi comprada!
        </div>

        <div style={{fontSize: '0.8em', padding: '15px'}} className="rainbow">
          Não foi ele que instalou!
        </div>

        <br />

        <span>
          Se o Christian tivesse investido o dinheiro da placa de vídeo, ele poderia ter ganho: <br/>
          <span className="rainbow bold">{Number(fullCDI).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span> (considerando 100% CDI) <br />
          Ou <strong>{Number(littleMore).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</strong> (considerando <strong>110%</strong> CDI)
        </span>

        <br />
        <br />

        <span id="progress">
          <ProgressBar completed={Math.floor((daysUntilEnd/nextMilestoneValue) * 100)} maxCompleted={100} bgColor="#6a1b9a" height="40px" /> <br />
        </span>
      </div>
    </div>
  );
}

export default App;
